import React from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import AssessmentPeriodList from 'areas/assessment-schedule/components/AssessmentPeriodList';
import { getAssessmentPeriods, getSelectedAssessmentPeriodId, getCurrentOrganization } from 'common/selectors/auth';
import userContextSlice from 'common/slices/userContextSlice';
import { ASSESSMENT_PERIOD_OPEN, ASSESSMENT_PERIOD_CLOSED, ASSESSMENT_PERIOD_IN_PROGRESS } from 'areas/assessment-schedule/constants';

interface Props {
  status?: (typeof ASSESSMENT_PERIOD_OPEN | typeof ASSESSMENT_PERIOD_CLOSED | typeof ASSESSMENT_PERIOD_IN_PROGRESS)[];
  controls?: React.ReactNode;
}

const TopBarControls: React.FC<Props> = ({ status = [ASSESSMENT_PERIOD_CLOSED], controls }) => {
  const dispatch = useDispatch();
  const assessmentPeriods = useSelector(getAssessmentPeriods);
  const selectedAssessmentPeriodId = useSelector(getSelectedAssessmentPeriodId);
  const currentOrganization = useSelector(getCurrentOrganization);

  return (
    <ControlWrapper>
        <SelectContainer>
          <AssessmentPeriodList
            key={currentOrganization?.id ?? 'no-org'}
            currentOrganizationId={currentOrganization?.id}
            selectedAssessmentPeriodId={selectedAssessmentPeriodId}
            assessmentPeriods={assessmentPeriods}
            onChange={(value, period) => {
              // Use the period provided by the list if available (it's the freshest data from API);
              // otherwise fall back to the periods in the store.
              const selected = period ?? assessmentPeriods?.find(p => p.id === value);
              if (selected) {
                dispatch(
                  userContextSlice.actions.setSelectedAssessmentPeriod({
                    selectedAssessmentPeriod: selected,
                    assessmentPeriods,
                  })
                );
              }
            }}
            status={status} 
          />
        </SelectContainer>
      {controls}
    </ControlWrapper>
  );
};

export default TopBarControls;

// Styles
const ControlWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const SelectContainer = styled.div`
  border: 1px solid #ddd;
  border-radius: 4px;
  display: flex;
  align-items: center;
  padding: 6px 10px;
  min-height: 34px;
  background-color: #fff;
`;
